/**
 * Legacy hook: organization-scoped application modules are removed; views replace that surface.
 */
export const useOrganizationModulesConfig = () => ({
  data: [],
  isLoading: false,
  error: null,
});
